import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IonContent } from '@ionic/react';

import { screen } from '$fcomponents/hoc';
import { TableView2, Header } from '$gcomponents/widgets';

import { IonPageWrapper } from './styles';
import FactoryModel from '$fbusiness/models/factory';
import CurrentStateModel from '$fbusiness/models/currentState';
import ItemActionModel from '$gbusiness/models/itemAction';
import { factoryActions } from '$fbusiness/redux/factory';
import { dialog } from '$gcomponents/reusables';
import { configs } from '$configs';
import FabButton from '$fcomponents/fabButton';
import { accessHide, getAccess, isAccessible } from '$fbusiness/helpers/util';
import { STORE_LEVEL_TABLE, STORE_LEVEL_TABLE_CONFIG } from './storeLevelTable';
import StoreLevelEditModal from './storeLevelEditModal';
import { initialStoreLevel } from '$fbusiness/models/storeLevel';

interface StoreLevelsScreenProps {
  factory: FactoryModel;
  deleteObj: Function;
  currentState: CurrentStateModel;
}

const StoreLevelsScreen: React.FC<StoreLevelsScreenProps> = ({ factory, deleteObj, currentState }) => {
  const [storeLevel, setStoreLevel] = useState<any>(null);

  const ACCESS = getAccess(currentState);

  if (!factory) return <IonPageWrapper />;
  const { storeLevels } = factory;

  const onCloseModal = async () => {
    setStoreLevel(null);
  };

  const itemActions: Array<ItemActionModel> = [
    {
      label: 'BUTTON.EDIT',
      eventName: 'editItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.TERM.EDIT, currentState),
      onClick: setStoreLevel,
    },
    {
      label: 'BUTTON.DELETE',
      eventName: 'deleteItem',
      disabled: () => !isAccessible(ACCESS.ACTION.SETTING.TERM.DELETE, currentState),
      onClick: (row) => {
        dialog.confirm({
          message: 'MESSAGE.DELETE_STORE_LEVEL_WARNING',
          onPress: async () => {
            await deleteObj(row.id, configs.api.storeLevel, factoryActions.fetchStoreLevels);
          },
        });
      },
    },
  ];

  return (
    <IonPageWrapper>
      <Header title="SCREEN.STORE_LEVELS.TITLE" />
      <IonContent>
        <TableView2
          data={storeLevels}
          tableConfig={STORE_LEVEL_TABLE_CONFIG}
          TABLE={STORE_LEVEL_TABLE()}
          itemActions={itemActions}
        />
      </IonContent>
      <StoreLevelEditModal storeLevel={storeLevel} onClose={onCloseModal} />
      <FabButton
        onClick={() => setStoreLevel(initialStoreLevel)}
        className={accessHide(ACCESS.ACTION.SETTING.TERM.CREATE)}
      />
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  factory: state.factory.factory,
  resetOnRoute: true,
});

const mapDispatchToProps = {
  deleteObj: factoryActions.deleteObj,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(StoreLevelsScreen));
